<div [className]="'card-' + this.type + '-container'" *ngIf="type === 'single'" [style.--card-width]="cardWidth" [style.height]="cardHeight"
  [tp]="getTooltip().length > 0 ? tooltipTemplate : null" [tpClassName]="'custom-tooltip'" [tpPlacement]="'bottom'">
  <div class="card-header">
    <div class="title-container">
      <span class="card-title">{{ title }}</span>
      <app-tooltip-icon *ngIf="titleTooltip" [text]="titleTooltip" [place]="titleTooltipPlace" class="tooltip"></app-tooltip-icon>
    </div>
    <img *ngIf="iconPath" [ngSrc]="iconPath | assetVersion" alt="Icon" width="24" height="24" />
  </div>
  <div class="card-body">
    <span [className]="!!value ? 'card-single' : 'no-data-card-single'">
      <span class="card-value {{ valueType }}">{{ value || '-' }}</span>
      <span *ngIf="valueDescription" class="card-description">{{ valueDescription }}</span>
      <span *ngIf="trend" class="trend-chip" [ngClass]="trend.status"
        [matTooltip]="trendTooltip" matTooltipClass="tooltip-with-triangle" >
        <app-arrow-icon *ngIf="trend.value" [direction]="trend.arrowDirection" [color]="trend.status" ></app-arrow-icon>
        <span>{{ trend.value }}%</span>
      </span>
    </span>
    <app-loader *ngIf="loading"></app-loader>
  </div>
  <ng-template #tooltipTemplate>
    <app-overview-tooltip *ngIf="getTooltip().length" [data]="getTooltip()" ></app-overview-tooltip>
  </ng-template>
</div>

<div [className]="'card-' + this.type + '-container'" *ngIf="type === 'multiple'" [style.--card-width]="cardWidth">
  <div class="card-header">
    <span class="card-title">{{ title }}</span>
    <img *ngIf="iconPath" [ngSrc]="iconPath | assetVersion" alt="Icon" width="24" height="24" />
  </div>
  <div class="card-body">
    <div class="card-multiple">
      <div class="multiple-row" *ngFor="let metric of metrics"
        [tp]="getTooltip(metric).length > 0 ? tooltipTemplate : null" [tpClassName]="'custom-tooltip'" [tpPlacement]="'bottom'">
        <ng-template #tooltipTemplate>
          <app-overview-tooltip *ngIf="getTooltip(metric)?.length" [data]="getTooltip(metric)"></app-overview-tooltip>
        </ng-template>
        <span class="multiple-title">{{ metric.title }} </span>
        <span class="{{ metric.valueType }}" [ngClass]="{ 'multiple-data': metric.value != null, 'no-data-card-multiple': metric.value == null }">
          {{ metric.value || '-' }}
        </span>
      </div>
    </div>
  </div>
  <app-loader *ngIf="loading"></app-loader>
</div>

